import { render } from "./ContentEditPage.vue?vue&type=template&id=33286ce4&scoped=true"
import script from "./ContentEditPage.vue?vue&type=script&lang=js"
export * from "./ContentEditPage.vue?vue&type=script&lang=js"

import "./ContentEditPage.vue?vue&type=style&index=0&id=33286ce4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33286ce4"]])

export default __exports__